import React from 'react'
import { Provider } from 'react-redux'
import { Router } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'
import { BugReportingWrapper } from '@offerzen/react-utils'

import { MediaQueryProvider } from '@offerzen/pinata-shame'

import configureStore, { createReduxHistory } from './core/config/store'
import ErrorUser from './core/containers/ErrorUser'
import rootSaga from './core/sagas'
import CandidateExperienceMain from './core/Main'
import CandidateExperienceError from './core/scenes/CandidateExperienceError'

const App = () => {
  const store = configureStore()
  const history = createReduxHistory(store)

  store.registerSaga('root', rootSaga)

  const reactQueryClient = new QueryClient()

  return (
    <QueryClientProvider client={reactQueryClient}>
      <Provider store={store}>
        <ErrorUser>
          {({ errorUser }) => (
            <BugReportingWrapper
              errorHandlingEnabled={process.env.REACT_APP_ERROR_HANDLING_ENABLED === 'true'}
              errorHandlingEndpoint={process.env.REACT_APP_ERROR_HANDLING_ENDPOINT}
              fallback={<CandidateExperienceError user={errorUser} />}
              service="candidate-experience"
              environment={process.env.REACT_APP_ENVIRONMENT}
              releaseId={process.env.REACT_APP_APP_VERSION}
              user={errorUser}>
              <Router history={history}>
                <MediaQueryProvider>
                  <CandidateExperienceMain />
                </MediaQueryProvider>
              </Router>
            </BugReportingWrapper>
          )}
        </ErrorUser>
      </Provider>
      <If condition={process.env.NODE_ENV === 'development'}>
        <ReactQueryDevtools initialIsOpen={false} />
      </If>
    </QueryClientProvider>
  )
}

export default App
